import { formatGrade } from "../../utils/format";

/**
 * The outstanding-jerseys export, one line per player still owed a jersey.
 * Grade sits beside the player: the club packs by year group.
 */
export const OUTSTANDING_CSV_HEADERS = [
  "Player",
  "Grade",
  "Size",
  "Class",
  "Parent",
  "Email",
  "Phone",
  "Address",
  "City",
  "State",
  "Zip",
];

export const outstandingCsvRow = (row, formatSize) => [
  row.child_name || "",
  formatGrade(row.grade),
  formatSize(row.jersey_size),
  row.class_name || "",
  row.parent_name || "",
  row.parent_email || "",
  row.parent_phone || "",
  row.address || "",
  row.city || "",
  row.state || "",
  row.zip_code || "",
];
